import { useState } from 'react';

import { Dialog, DialogContent } from '@/components/ui/dialog';

import { useCreateApiKeyMutation } from '@/query/api-key.query';

import { ApiKeyCreateForm } from './components/create-form';
import { ApiKeyCreateSuccess } from './components/success';

import { ApiKeyCreateFormProvider } from '@/formik/api-key.formik';

type Props = {
  toggle: () => void;
};

export const ApiKeysCreatePage = ({ toggle }: Props) => {
  const [privateKey, setPrivateKey] = useState<string>('');
  const mutation = useCreateApiKeyMutation({
    onSuccess: data => {
      setPrivateKey(data);
    },
  });

  return (
    <Dialog
      open={true}
      onOpenChange={() => {
        toggle();
        setPrivateKey('');
      }}
    >
      <DialogContent className="sm:max-w-[500px]">
        {!privateKey ? (
          <ApiKeyCreateFormProvider onSubmit={mutation.mutate}>
            <ApiKeyCreateForm isLoading={mutation.isPending} toggle={toggle} />
          </ApiKeyCreateFormProvider>
        ) : (
          <ApiKeyCreateSuccess
            apiKey={privateKey}
            toggle={() => {
              toggle();
              setPrivateKey('');
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
